export enum DataStatus {
  LOADING = "loading",
  LOADED = "loaded",
  ERROR = "error",
  PENDING = "pending",
  SAVED = "saved",
  SENDING = "sending",
  UPDATING = "updating",
}

export enum PaymentStatus {
  CANCELLED = "cancelled",
  ERROR = "error",
  PAID = "paid",
  READY = "ready",
  SENT = "sent",
  VOIDED = "voided",
}

export enum InvoiceStatus {
  READY = "ready",
  PAID = "paid",
  ERROR = "error",
  DO_NOT_PAY = "do-not-pay",
}
